<template>
  <!-- <van-search v-model="searchText" :placeholder="$t('menu.search')" @search="onClickSearch" /> -->
  <van-search
    shape="round"
    class="wc-search"
    v-model="searchText"
    :placeholder="placeholder"
    @search="$emit('search', searchText)"
    @input="$emit('input', searchText)"
  />
</template>

<script>
export default {
  //name: "wcSearchBox",
  props: ["placeholder"],
  data() {
    return {
      searchText: "",
    };
  },
  mounted() {},
  methods: {
    // ------------------------------------------------------------------------ onClickSearch
    /*onClickSearch() {
      let $this = this;
      $this.$store.commit("productList", {
        text: $this.searchText
      });
      $this.$router.push({ name: "productList" });
    }*/
  },
};
</script>

<style>
/*
.wc-search-box2 {
  font-size: 18px;
  margin-top: 6px;
  border-radius: 30px;
  border: 1px solid lightgray;
  background-color: #f4f4f4;
}
.wc-search2 {
  padding: 0px;
  background-color: transparent !important;
}
*/
</style>
